module.exports = __webpack_public_path__ + "static/img/indie-prize-casual-connect-lucre-games-2018.9150e2b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promo/indie-prize-casual-connect-lucre-games-2018.png
// module id = m1Vw
// module chunks = 0